import { observer } from "mobx-react";
import React from "react";
import LoadingIndicatorWrapper from "../Components/LoadingIndicatorWrapper";
import StepsNavigation from "../Components/StepsNavigation";
import SummaryHeader from "../Components/SummaryHeader";
import SummaryWrapper from "../Components/SummaryWrapper";
import { generalConfigurationStore as store} from "../Stores/GeneralConfigurationStore";
import "./ConfigurationPage.css";

type Props = {};

type State = {
	title: string;
	pageIsActive: number;
};

@observer
class SummaryPage extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		// set initial state
		this.state = {
			title: "SummaryPage",
			pageIsActive: 2,
		};
	}

	componentDidMount() {
		this.setState({
			title: "SummaryPage Loaded",
		});
	}

	render() {
		const pS = store.productConfigurationStore
		if (!pS)
			return <div/>
			
		const selectedModulesCounter = pS.formattedNumberOfSelectedModules;

		return (
			<div className="configuration-page">
				{pS.isLoading ? <LoadingIndicatorWrapper /> : <>
					<StepsNavigation pageIsActive={this.state.pageIsActive} sublineStep1={selectedModulesCounter} />
					<SummaryHeader selectedModulesCounter={selectedModulesCounter} />
					<SummaryWrapper />
				</>}
			</div>
		);
	}
}

export default SummaryPage;
